// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sf-9";
export var arrowButtonContainer = "_sf-5";
export var arrowButtonIcon = "_sf-6";
export var carouselArrowButton = "_sf-2";
export var carouselElementContainer = "_sf-1";
export var currentSlide = "_sf-8";
export var left = "_sf-3";
export var otherSlide = "_sf-a";
export var productCarouselContainer = "_sf-0";
export var right = "_sf-4";
export var sliderOverflow = "_sf-7";